import React from 'react';
import { Box } from '@mui/material';
import Highlighter from 'react-highlight-words';
import { SUBSCRIPTIONS_STATUSES } from '@constants';
import { getSubscriptionStatusColor } from 'helpers/sidebarGenericTicket';
import styles from './subscriptionAutocompleteOption.style';
import { HIGHLIGHT_STYLE } from '../constants';

const SubscriptionAutocompleteOption = ({
  autoCompleteProps,
  option,
  searchTerm,
}) => {
  const subscription = option.subscription || {};
  const vehicleBrand = subscription.vehicle?.manufacturer || '';
  const vehicleModel = subscription.vehicle?.model || '';
  const vehicleName = `${vehicleBrand} ${vehicleModel}`.trim() || '-';
  const plate = subscription.vehiclePlate || subscription.vehicle?.plate || '';
  const email =
    subscription.subscribers?.[0]?.email || subscription.owner?.email || '';
  const statusText = SUBSCRIPTIONS_STATUSES[subscription.status] || '-';
  const statusColor = getSubscriptionStatusColor(subscription.status);

  const searchWords = searchTerm ? [searchTerm] : [];

  return (
    <Box
      component="li"
      {...autoCompleteProps}
      key={option.value || 'key'}
      sx={styles.container}
    >
      <Box sx={styles.content}>
        <Box sx={styles.vehicleName}>
          <Highlighter
            highlightStyle={HIGHLIGHT_STYLE}
            searchWords={searchWords}
            autoEscape
            textToHighlight={vehicleName}
          />
        </Box>
        <Box sx={styles.detailsRow}>
          {email && (
            <>
              <Box>
                <Highlighter
                  highlightStyle={HIGHLIGHT_STYLE}
                  searchWords={searchWords}
                  autoEscape
                  textToHighlight={email}
                />
              </Box>
              <Box>-</Box>
            </>
          )}
          <Box>
            <Highlighter
              highlightStyle={HIGHLIGHT_STYLE}
              searchWords={searchWords}
              autoEscape
              textToHighlight={plate}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={styles.statusBadge(statusColor)}>
        <Box sx={styles.statusDot(statusColor)} />
        <Box sx={styles.statusText(statusColor)}>{statusText}</Box>
      </Box>
    </Box>
  );
};

export default SubscriptionAutocompleteOption;
